<template>
  
  <v-footer  width="100%" tile="" 
    padless absolutee class="white">
    <!-- <v-content >  -->
      <v-layout column=" ">
        <v-divider></v-divider>
        <!-- <v-container grid-list-xs> -->
          <!-- //BACKUP -->
          <div v-if="false"> 
            <v-col sm="4" class="">
              <v-layout class="" align-center="" fill-height="">
                <v-card flat to="/" color="transparent">
                  <v-layout column align-center class="">
                    <v-img    
                      max-width="300"
                      :src="'/masoathu/logo.png'"
                      />  
                    <!-- <div class="not-f4 font-weight-bold primary--text">TIDZIWE</div> -->
                    <!-- <div class="not-f3 font-weight-bold accent--text ">Early Warning Governance System</div> -->
                    
                  </v-layout>
                </v-card>
              </v-layout>
            </v-col>
            <v-col sm="4" class="">
              <v-layout class="" align-center="" fill-height="">
                <v-card flat to="/" color="transparent">
                  <v-layout column align-center class="">
                    <v-img    
                      max-width="300"
                      :src="'/masoathu/org/mw.jpg'"
                      />   
                  </v-layout>
                </v-card>
              </v-layout>
            </v-col>
            <v-col sm="4">
              <!-- <v-layout align-center="" justify-center="">
                <a href="http://mhubmw.com/" target="_blank" rel="noopener noreferrer">
                  <v-img    
                    max-width="180"
                    :src="require(`@/assets/logo/mhub.png`)"
                    />  
                </a>
              </v-layout> -->
            </v-col>
          </div>
          <v-layout column="" class="white lighten-4 pt-2" >  
            <mbs-show-logo
                :height="50"
                :itemsPerPage="per_page_logo"
                :color="'white lighten-3'"
                :items="footer_logos"/> 
          </v-layout> 


          <!-- //LOGOS -->
          <v-row class="white" v-if="false">
            <v-col sm="4" v-for="(logo,index) in footer_logos">
              <v-layout fill-height justify-center align-center> 
                <a v-if="logo.link" :href="logo.link" :target="logo.link?'_blank':''" rel="noopener noreferrer">
                  <v-img   
                    max-width="150"
                    :src="logo.path"
                    />  
                </a> 
                <v-img v-else
                  max-width="150"
                  :src="logo.path"
                  />  
              </v-layout>
            </v-col>
          </v-row>
        <!-- </v-container> -->
        <v-divider></v-divider> 
        <div class="b1 darken-">
          <v-container >
            <a href="https://mberaenterprise.com/" target="_blank" rel="noopener noreferrer" class=" not-line0">
              <v-layout justify-center="" align-center="">
                <!-- <strong class="not-f3 pr-1">&copy;</strong> 
                {{ new Date().getFullYear()}} -->
                <strong > Masoathu Powered by mHub.</strong>
              </v-layout>  
            </a>
          </v-container>

        </div>
      </v-layout>
    <!-- </v-content> -->
  </v-footer>
</template>

<script>
export default {
  props:["not"],
  data: () => ({ 
    icons: [ 
      {name:"googleplus",src:"fab fa-google-plus",link:""},  
        // 'fab fa-linkedin',
        // 'fab fa-instagram',
    ],
    footer_logos: [ 
      // {name:"",path:"/masoathu/logo.png",link:""},   
      {name:"",path:"/masoathu/org/mw.jpg",link:""},   
      {name:"",path:"/masoathu/org/eu.png",link:""},   
      {name:"",path:"/masoathu/org/commonwealth.png",link:""},   
      {name:"",path:"/masoathu/org/osisa-logo.jpg",link:""},   
      {name:"",path:"/masoathu/org/tilitonse.png",link:""},   
      {name:"",path:"/masoathu/nice.png",link:"http://nice.mw/"},   
    ],
  }),
  computed:{
          vs(){
            return this.$vuetify.breakpoint
          }, 
          per_page_services(){
              let n = 0 
              name = this.vs.name
              if(name=="xs"){
                  n = 3
              }else if (name=='sm') {
                  n = 4
              }else{
                  n = 6
              }
              return n
          },
          per_page_designs(){
              let n = 0 
              name = this.vs.name 
              if(name=="xs"){
                  n = 2
              }else if (name=='sm') {
                  n = 3
              }else if (name=='md') {
                  n = 4
              }else if (name=='lg') {
                  n = 5
              }else if (name=='xl') {
                  n = 6
              }else{
                  n = 7
              }
              return n
          },
          per_page_logo(){
              let n = 0 
              name = this.vs.name 
              if(name=="xs"){
                  n = 3
              }else if (name=='sm') {
                  n = 4
              }else if (name=='md') {
                  n = 6
              }else if (name=='lg') {
                  n = 7
              }else if (name=='xl') {
                  n = 8
              }else{
                  n = 9
              }
              return n
          },
           
          
        },
};
</script>
